import { BASE_PATHS, PATHS } from '@belong/common';
import { REVIEWS_URLS } from 'src/features/reviews/reviews.urls';

export const WHO_WE_ARE_COLUMN_LINKS = [
  {
    to: PATHS.ABOUT_US,
    label: 'ABOUT',
  },
  {
    to: PATHS.BLOG,
    label: 'BLOG',
  },
  {
    to: REVIEWS_URLS.REVIEWS,
    label: 'REVIEWS',
  },
  {
    to: PATHS.CAREERS,
    label: 'CAREERS',
  },
  {
    to: '/pros',
    label: 'BECOME A PRO',
  },
  {
    to: PATHS.TERMS,
    label: 'TERMS',
  },
  {
    to: PATHS.PRIVACY_POLICY,
    label: 'PRIVACY',
  },
];

export const SUPPORT_COLUMN_LINKS = [
  {
    to: PATHS.SUPPORT,
    label: 'GET HELP',
  },
  {
    to: PATHS.FAQ,
    label: 'FAQ',
  },
  {
    to: PATHS.SITEMAP,
    label: 'SITEMAP',
  },
];

export const BELONG_PRO_LINKS = [
  {
    to: BASE_PATHS.HOMEOWNER,
    label: 'FOR HOMEOWNERS',
  },
  {
    to: BASE_PATHS.HOME, // TODO: to be defined
    label: 'FOR RESIDENTS',
  },
  {
    to: '/homeowners/income-lock',
    label: 'INCOME LOCK',
    badge: 'NEW',
  },
  {
    to: `${PATHS.SITEMAP}/homeowners-coverage-regions`,
    label: 'COVERAGE REGIONS',
  },
  {
    to: `${PATHS.SITEMAP}/homeowners-coverage-cities`,
    label: 'COVERAGE CITIES',
  },
  {
    to: `${PATHS.SITEMAP}/homeowners-coverage-neighborhoods`,
    label: 'COVERAGE NEIGHBORHOODS',
  },
  {
    to: PATHS.SITEMAP_HOMES_TO_LOVE,
    label: 'AVAILABLE HOMES',
  },
  {
    to: PATHS.AFFILIATE,
    label: 'AFFILIATE PROGRAM',
  },
  {
    to: PATHS.REFERRAL_LANDING,
    label: 'REFER FOR',
  },
];
